export default __webpack_public_path__ + "static/media/aws.07cc8970.svg";